import type { vendorApiNames } from '../names';
import type {
  BaseUpdateVendorApiSettings,
  BaseUrl,
  BaseVendorApi,
  RejectUnauthorized,
} from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';
import type { VendorApiSessionSettings } from './session';

export interface ForcePointAuthentication {
  authenticationKey: string;
}

/**
 * ForcePoint API settings available from API
 */
export type PublicForcePointApiSettings = BaseVendorApi<
  (typeof vendorApiNames)['forcepoint']
> &
  RejectUnauthorized &
  BaseUrl &
  VendorApiHttpAgentSettings &
  VendorApiSessionSettings &
  VendorApiHttpAdvancedSettings;

/**
 * ForcePoint API settings available in backend
 */
export type ForcePointApiSettings = PublicForcePointApiSettings &
  ForcePointAuthentication;

/**
 * ForcePoint API settings expected on API when updating
 */
export type UpdateForcePointApiSettings = BaseUpdateVendorApiSettings<
  PublicForcePointApiSettings,
  ForcePointAuthentication
>;
